export const TYPES = {
  GET_USER_INFO_SUCCESS: "user/GET_USER_INFO_SUCCESS",
  SELECT_ALL_USER_SUCCESS: "user/SELECT_ALL_USER_SUCCESS",
  SELECT_USERS_SUCCESS: "user/SELECT_USERS_SUCCESS",
};
